module.exports = __webpack_public_path__ + "img/old_burnt_fault.50cd23a4.svg";